@let loading = isLoading();
@let treeLoaded = isTreeLoaded();

@let isImportMode = operationMode() === OperationMode.Import;
@let isExportMode = operationMode() === OperationMode.Export;

@let isSingleFileSelectionMode = selectionMode() === SelectionMode.SingleFile;
@let isMultipleFilesSelectionMode = selectionMode() === SelectionMode.MultipleFiles;
@let isSingleFolderSelectionMode = selectionMode() === SelectionMode.SingleFolder;
@let isMultipleFoldersSelectionMode = selectionMode() === SelectionMode.MultipleFolders;
@let isSingleFileOrFolderSelectionMode = selectionMode() === SelectionMode.SingleFileOrFolder;

@let isFileSelectionMode = isSingleFileSelectionMode || isMultipleFilesSelectionMode;
@let isFolderSelectionMode = isSingleFolderSelectionMode || isMultipleFoldersSelectionMode;

@let isSingleSelectionMode = isSingleFileSelectionMode || isSingleFolderSelectionMode || isSingleFileOrFolderSelectionMode;
@let isMultipleSelectionMode = isMultipleFilesSelectionMode || isMultipleFoldersSelectionMode;

@let userInterfaceSelectionMode = isExportMode ? "single" : "checkbox";

@let selection = isExportMode ? selectedNodes()?.[0] : selectedNodes();

<div class="file-manager-dialog-header">
  <h4 class="title">
    <span *ngIf="isSingleFileSelectionMode">{{ "fileManager.importFile" | translate }}</span>
    <span *ngIf="isMultipleFilesSelectionMode">{{ "fileManager.importFiles" | translate }}</span>
    <span *ngIf="isSingleFolderSelectionMode">{{ "fileManager.importFolder" | translate }}</span>
    <span *ngIf="isMultipleFoldersSelectionMode">{{ "fileManager.importFolders" | translate }}</span>
    <span *ngIf="isSingleFileOrFolderSelectionMode">{{ "fileManager.saveFile" | translate }}</span>
  </h4>
  <span class="close-icon pi pi-times" mat-dialog-close></span>
</div>

<mat-dialog-content class="file-manager-dialog-content">
  <div class="toolbar-container">
    <evc-nav-button type="tertiary" (click)="refreshView()" [disabled]="loading" size="sm">
      <i class="pi pi-sync" [ngClass]="{ 'pi-spin': loading }"></i>
      <span>{{ "fileManager.refresh" | translate }}</span>
    </evc-nav-button>

    <div class="heading-container">
      <span class="pi pi-info-circle heading-icon"></span>
      <p class="heading">
        <span *ngIf="isSingleFileSelectionMode">{{ "fileManager.selectFileToImport" | translate }}</span>
        <span *ngIf="isMultipleFilesSelectionMode">{{ "fileManager.selectFilesToImport" | translate }}</span>
        <span *ngIf="isSingleFolderSelectionMode">{{ "fileManager.selectFolderToImport" | translate }}</span>
        <span *ngIf="isMultipleFoldersSelectionMode">{{ "fileManager.selectFoldersToImport" | translate }}</span>
        <span *ngIf="isSingleFileOrFolderSelectionMode">{{ "fileManager.choseFolderAndFileName" | translate }}</span>
      </p>
    </div>
  </div>

  <div class="file-system-tree-container">
    <div class="spinner-container" *ngIf="!treeLoaded">
      <mat-spinner mode="indeterminate" />
    </div>

    <p-tree
      *ngIf="treeLoaded"
      [loading]="loading"
      loadingMode="icon"
      [value]="fileSystemTree()"
      [selection]="selection"
      [selectionMode]="userInterfaceSelectionMode"
      (onNodeExpand)="onNodeExpand($event)"
      (onNodeSelect)="onNodeSelect($event)"
      (onNodeCollapse)="onNodeCollapse($event)"
      (onNodeUnselect)="onNodeUnselect($event)"
      [metaKeySelection]="isMultipleSelectionMode"
      [propagateSelectionUp]="false"
      [emptyMessage]="'fileManager.insertExternalDriveMessage' | translate"
    />
  </div>
</mat-dialog-content>

<mat-dialog-actions class="buttons-container dialog-action" [align]="'end'">
  <div class="filename-input-container">
    <mat-form-field class="filename-input" appearance="outline" *ngIf="isExportMode">
      <mat-label class="filename-input-label">{{ "fileManager.fileName" | translate }}</mat-label>
      <input appVirtualKeyboard matInput type="text" [placeholder]="'fileManager.enterFileName' | translate" [(ngModel)]="fileName" />
    </mat-form-field>
  </div>

  <evc-nav-button type="primary" variant="semi" [disabled]="!enableActionButton()" (click)="isImportMode ? importFiles() : exportFiles()">
    <span *ngIf="isImportMode">{{ "fileManager.import" | translate }}</span>
    <span *ngIf="isExportMode">{{ "fileManager.export" | translate }}</span>
  </evc-nav-button>
</mat-dialog-actions>
